import { ENV } from '../config/environment';
import { firebaseLogger } from '../utils/logger';

interface CreateSessionRequest {
  workspace_id: string;
}

interface CreateSessionResponse {
  session_id: string;
  token: string;
  fbcreds: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
  };
}

/**
 * Create a new session with the backend
 * Uses environment-based API URL
 */
export const createSession = (req: CreateSessionRequest): Promise<CreateSessionResponse> => {
  const apiUrl = `${ENV.apiBaseUrl}/createSession`;
  
  firebaseLogger.debug('Creating session', { workspace_id: req.workspace_id, apiUrl });
  
  return fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(req),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Error creating session: ${response.statusText}`);
      }
      return response.json();
    })
    .then((data) => {
      firebaseLogger.debug('Session created successfully');
      return data as CreateSessionResponse;
    })
    .catch((error) => {
      firebaseLogger.error('Failed to create session', error);
      throw error;
    });
};
